import { replacePathParams } from '@/api/utils';

export const homeLocationApiPaths = {
  homeLocationById: '/facilityservice/homelocations/:id',
  homeLocations: '/facilityservice/homelocations',
} as const;

export const getHomeLocationApiUrl = {
  homeLocationById: (id: string) => replacePathParams(homeLocationApiPaths.homeLocationById, { id }),
  homeLocations: () => homeLocationApiPaths.homeLocations,
};
